module.exports = __webpack_public_path__ + "img/weights3.44cf3bcc.png";